<template>
  <el-dialog title="查看课时内容" :visible.sync="showContentDialog" :center="true" width="700px">
    <div
      class="rich-auto"
      v-html="chapter_content"
      @contextmenu="
        ($event) => {
          $event.preventDefault();
        }
      "
    ></div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="showContentDialog = false"> 确定 </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'CourseContentTip',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showContentDialog: false,
    };
  },
  created() {
    this.showContentDialog = this.show;
    this.chapter_content = this.content;
  },
  watch: {
    showContentDialog() {
      this.$emit('update:show', this.showContentDialog);
    },
    show() {
      this.showContentDialog = this.show;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  ::v-deep {
    .el-dialog {
      width: 480px;
      height: 224px;
      text-align: center;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 23px 0 22px 0;
    }
    .el-dialog__footer {
      text-align: center;
      padding: 0 0 22px 0;
      .el-button {
        padding: 10px 41px;
      }
    }
  }
}
.img {
  width: 136px;
  height: 104px;
  vertical-align: middle;
}
.tip {
  font-size: 16px;
  color: rgba(26, 26, 26, 1);
  line-height: 1;
}
.close {
  position: absolute;
  width: 20px;
  top: 3px;
  right: -42px;
  cursor: pointer;
}
</style>
